window.$ = window.jQuery;

$(document).ready(function() {
  $(".numslider").numSlider();
});
